import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menua13",
  "use": "menua13-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"menua13\"><path d=\"M352 373.333333h320v64h-320zM352 501.333333h320v64h-320zM352 629.333333h192v64h-192z\" p-id=\"16297\" /><path d=\"M768 149.333333H256c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64V213.333333c0-35.2-28.8-64-64-64z m0 704H256V213.333333h512v640z\" p-id=\"16298\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol